export default __webpack_public_path__ + "static/media/icon_length.17cf8d7f.png";